<template>
  <b-container fluid id="full-view-modal">
    <div id="full-view">
      <img ref="fullImage" alt="image">
      <button id="close-modal" @click="closeModalPhoto()">
        <font-awesome-icon :icon="['far', 'times-circle']" fixed-width />
      </button>
      <button v-if="!disableControls" id="prev-image" @click="$emit('prev-photo')">
        <i class="fas fa-chevron-circle-left"></i>
      </button>
      <button v-if="!disableControls" id="next-image" @click="$emit('next-photo')">
        <i class="fas fa-chevron-circle-right"></i>
      </button>
    </div>
  </b-container>
</template>

<script>
  export default {
    name: 'ImageFullModal',
    props: {
      imageUrl: {
        type: String,
        required: true
      },
      disableControls: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    mounted () {
      const imageContainer = document.getElementById('full-view-modal')
      imageContainer.style.display = 'block'
      const image = imageContainer.querySelector('img')
      image.src = this.imageUrl
    },
    methods: {
      closeModalPhoto () {
        const imageContainer = document.getElementById('full-view-modal')
        imageContainer.style.display = 'none'
        this.$emit('close-modal')
      },
    }
  }
</script>